//Allows bootstrap carousels to display 3 items per page rather than just one
$('.carousel.carousel-multi .item').each(function () {
	var next = $(this).next();
	if (!next.length) {
		next = $(this).siblings(':first');
	}
	next.children(':first-child').clone().attr("aria-hidden", "true").appendTo($(this));

	if (next.next().length > 0) {
		next.next().children(':first-child').clone().attr("aria-hidden", "true").appendTo($(this));
	}
	else {
		$(this).siblings(':first').children(':first-child').clone().appendTo($(this));
	}
});

$(".fancybox").fancybox({
    type: "iframe",
    // other API options
})

$(".fancybos").fancybox({
    type: "iframe",
    // other API options
}) 


$(".carousel").carousel({
  interval: false
})

function ready(fn) {
  if (document.readyState != 'loading'){
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

// run the function inside this method when page finished loading
ready(function(){
  // hide second element
  if(document.getElementsByClassName('yotpo-review').length){
    document.getElementsByClassName('yotpo-review')[1].style.display = 'none';
    document.getElementsByClassName('yotpo-review')[2].style.display = 'none';
  }
  
})